/**
 * Map Module Routes
 *
 * Auth-required routes live here (loaded by module system into DefaultLayout).
 * Public routes live in publicRoutes (registered at top level in router/index.ts).
 */

import type { RouteRecordRaw } from 'vue-router'

/**
 * Auth-required routes — injected into DefaultLayout by the module loader.
 * The main map and settings both require auth.
 */
const routes: RouteRecordRaw[] = [
    {
        path: '/showcases/map',
        component: () => import('@/layouts/ModuleLayout.vue'),
        children: [
            {
                path: '',
                name: 'map-home',
                component: () => import('./views/ShowcaseMapView.vue'),
                meta: {
                    title: 'Showcase Map',
                    requiresAuth: true,
                },
            },
            {
                path: 'settings',
                name: 'map-settings',
                component: () => import('./views/MapSettings.vue'),
                meta: {
                    title: 'Map Settings',
                    requiresAuth: true,
                    moduleKey: 'showcases',
                },
            },
        ],
    },
]

/**
 * Public routes — registered at the top level (outside DefaultLayout)
 * so they bypass the auth guard entirely.
 *
 * URL pattern: /showcases/map/public/:orgId
 * The orgId in the URL ensures the correct tenant's data is loaded.
 */
export const publicRoutes: RouteRecordRaw[] = [
    {
        path: '/showcases/map/public/:orgId',
        name: 'public-map',
        component: () => import('./views/PublicMapView.vue'),
        meta: {
            title: 'Map',
            requiresAuth: false,
            isPublicMap: true,
        },
    },
    {
        path: '/showcases/map/public/:orgId/:id',
        name: 'public-map-detail',
        component: () => import('./views/ClientShowcaseView.vue'),
        meta: {
            title: 'Showcase',
            requiresAuth: false,
            isPublicMap: true,
        },
    },
]

export default routes
